﻿import { IntegerEditor, StringEditor, Widget, PrefixedContext, initFormType } from "@serenity-is/corelib";

export interface CreateFolderForm {
    ProjectId: IntegerEditor;
    Name: StringEditor;
    ParentFolder: Widget;
}

export class CreateFolderForm extends PrefixedContext {
    static readonly formKey = 'Cemdo.Default.CreateFolderRequest';
    private static init: boolean;

    constructor(prefix: string) {
        super(prefix);

        if (!CreateFolderForm.init)  {
            CreateFolderForm.init = true;

            var w0 = IntegerEditor;
            var w1 = StringEditor;
            var w2 = Widget;

            initFormType(CreateFolderForm, [
                'ProjectId', w0,
                'Name', w1,
                'ParentFolder', w2
            ]);
        }
    }
}